import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const triggersEating = useStore((state) => state.triggersEating);
  const setTriggersEating = useStore((state) => state.setTriggersEating);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.triggersEating.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={triggersEating}
          onChange={(value) => {
            setTriggersEating(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'triggers-eating',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Being around food"}>
            <span>🍕</span> {t('onboarding.triggersEating.options.around')}
          </Option>
          <Option value={"Boredom"}>
            <span>🥱</span> {t('onboarding.triggersEating.options.boredom')}
          </Option>
          <Option value={"Watching other people eat"}>
            <span>👀</span> {t('onboarding.triggersEating.options.watching')}
          </Option>
          <Option value={"Other"}>
            <span>✨</span> {t('onboarding.triggersEating.options.other')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
